import classNames from 'classnames';

import { LayoutProps } from '../LayoutProps';
import { InfoPanel } from './InfoPanel';

import styles from './Layout16x9.module.css';

export type Layout16x9Props = LayoutProps & {
    side?: 'top' | 'bottom';
};

export function Layout16x9({ side = 'bottom', clientID, game, children }: Layout16x9Props) {
    return (
        <div className={styles.container}>
            <div className={classNames(styles.linearGradient, side === 'top' ? styles.reverse : '')}>
                <InfoPanel clientID={clientID} game={game} />
            </div>
            <div className={styles.game}>{children}</div>
        </div>
    );
}
